export default {"src":"/_next/static/media/cde_icon.9315ac7d.svg","height":28,"width":28};